export const ENCRYPTIONKEY = "9z8x7c1m2n3b5l4k";
export const LOGIN = "connect/token";
export const api = "user/api/v1/";
export const APPOINMENT = "";
export const GETUSER = api + "UserMaster/GetUserDetails";
export const GETMENU = api + "LocalizationOfFunctions/GetBillerHamburgerMenu/";

export const GETMENUHEADER = api + "LocalizationOfFunctions/GetBillerMainMenu/";
export const GETMENUASSOCIATE = api + "AssociatedUser/GetAssociatedMenu";
export const GETTABLESECTION = api + "Restaurant/GetTableSectionList";
export const GETTABLE = api + "Restaurant/GetTableListV2";
export const ITEMCATEGORY = api + "ItemCategory/GetItemCategories";
export const GETASSOCIATEDMENU = api + "AssociatedUser/GetAssociatedMenu";
export const ITEMGET = api + "ItemsMaster/GetItems";
export const USERPROFILE = api + "UserMaster/GetUserProfile";
export const GETUSERPROFILE = api + "UserMaster/GetUserProfile";
// export const UPDATEUSERPROFILE = api + "UserMaster/UpdateUserProfile";
export const UPDATEUSERPROFILE = api + "UserMaster/UpdateUserProfile";
export const DELETEUSERPROFILE = api + "UserMaster/DeleteUserRequest";

export const USERPROFILEIMG = api + "UserMaster/GetUserProfile";
export const UPDATEUSERPROFILIMAGE = api + "UserMaster/ChangeProfilePicBase64";
export const GETBUSSINESSDATA = api + "MyBusiness/GetActiveBusiness";
export const ADDCOUNTERSALESCUTOMERDETAIL =
  api + "Salon/AddCounterSalesCustomerDetails";
// export const "http://103.13.114.194:4080/webapp/user/api/v1/"

export const UPDATEBUSSINESSDATA = api + "MyBusiness/Update";
export const UPDATECUSTOMERDETAIL =
  api + "Salon/UpdateCounterSalesCustomerDetails";
export const ADDOFFER = api + "Salon/AddOfferMessage";

// export const GETALLCUSTOMERDETAILFORSALON = api + "Salon/GetAllCustomerDetailsForSalon"
export const GETALLCUSTOMERDETAILFORSALON = api + "Salon/GetAllCustomerDetails";
export const GETALLCUSTOMERDETAILS =
  api + "Salon/GetAllCustomerDetailsForSalon";
export const GETALLCUSTOMERDETAILFORSALONXLSX =
  api + "Salon/GetAllCustomerDetailsForSalonXlsx";
export const UPDATEOFFERMESSAGE = api + "Salon/UpdateOfferMessage";

export const ADDBILL = api + "CounterSales/Add";
export const ADDBILLPARTPAYMENT = api + "CounterSales/AddwithPartPayment";
export const UPDATEBILLPARTPAYMENT = api + "CounterSales/UpdateWithPartPayment";
export const GETBILLPARTPAYMENT =
  api + "CounterSales/GetAllBillsWithPartPayment";
export const GETALLOFFER = api + "Salon/GetAllOfferMessage";

export const UPDATEBILL = api + "CounterSales/Update";
export const UPDATEIMAGE = api + "CounterSales/UpdateImageBill";

// export const GETBILL = api + "CounterSales/GetAllBills";

export const GETBILL = api + "CounterSales/GetAllBillsV2";

export const LASTSERVICEDETAILS = api + "Salon/GetCustomerLastServiceDetails";
export const UPDATECOUNTERSALESCUSTOMER =
  api + "Salon/UpdateCounterSalesCustomerDetails";
export const ADDTABLE = api + "Restaurant/AddTable";
export const GETDASHBOARDDATE = api + "ShowMyBills/GetBillerDashboardDetails";
export const GETMASTERTABLE = api + "Restaurant/GetTableList";

export const GETITEMS = api + "ItemsMaster/GetItems";
export const GETITEMSXLSX = api + "ItemsMaster/GetItemsXlsx";
export const ADDITEMS = api + "ItemsMaster/Add";
export const UPDATEITEMS = api + "ItemsMaster/UpdateItem";
export const ADDCATEGORIES = api + "ItemCategory/Add";
export const UPDATECATEGORIES = api + "ItemCategory/Update";

export const GETTABLESECTIONS = api + "Restaurant/GetTableSectionList";
export const GETNOTASSIGNTABLELIST = api + "Restaurant/GetNotAsssignTableList";
export const UPDATETABLESECTION = api + "Restaurant/UpdateTableSection";
export const ADDTABLESECTION = api + "Restaurant/AddTableSection";
export const GETITEMCATEGORIES = api + "ItemCategory/GetItemCategories";

export const UPDATETABLEMASTER = api + "Restaurant/UpdateTable";
export const GETASSOCIATEDUSERS = api + "AssociatedUser/GetAssociatedUsers";
export const ADDASSOCIATEDUSER = api + "AssociatedUser/AddAssociateUser";
export const UPDATEASSOCIATEDUSER = api + "AssociatedUser/UpdateAssociateUser";
export const GETACCOCIATEDUSERSSELECTEDMENU =
  api + "AssociatedUser/GetAssociatedUsersSelectedMenu";

export const GETALLEXPENSESCATEGORY = api + "Salon/GetAllExpensesCategory";
export const SETASSOCIATEDUSER =
  api + "AssociatedUser/SetAssociatedUsersSelectedMenu";
export const GETUNPAIDBILLS = api + "CounterSales/GetUnpaidBillsByBuyer";
export const GETPAYMENTRECEIPT = api + "CounterSales/GetPaymentReceipts";
// export const GETCOUNTERSALESCUSTOMERS =
//   api + "CounterSales/GetCouterSalesCustomers";
export const GETCOUNTERSALESCUSTOMERS = api + "salon/GetAllCustomerDetails";
export const GETACTIVEEMPLOYEELIST = api + "Salon/GetActiveEmployeeList";
export const TTLEASSISTNTPAYROLL =
  api + "CounterSales/SettleAssistantPayrollDetails";

export const GETASSITANCEPAYMENTPAYROLL =
  api + "CounterSales/GetAssistantPayrollDetailsForEmployee";
export const GETASSISTANTPAYROLLDETAIL =
  api + "CounterSales/GetAssistantPayrollDetailsV2";
export const GETALLADVANCEFOR =
  api + "BuyersInfo/GetAllCustomerAdvanceForSalon";
export const ADDCUSTOMERADVANCE = api + "BuyersInfo/AddCustomerAdvance";
export const ADDCASHPAYMENT = api + "CounterSales/AddCashPayment";

export const ADDBILLCASHRECEIPT = api + "PaymentReceipt/AddBillerCashReceipt";
export const GETPAYMENTXLSX = api + "CounterSales/GetPaymentReceiptsXlsx";
export const GETCOUNTERSELAESSTATEMENT =
  api + "Reports/ReportOutstandingCouterSalesStatement";
export const GETCOUNTERSALESpPAYROLL =
  api + "CounterSales/GetAssistantPayrollSearch";
export const GETACCOUNTRECHAGEDETAILS =
  api + "BuyersInfo/GetAccountRechargeDetails";

export const RAWMATERIALRPT = api + "Reports/RawMaterialRPT";
export const RAWMATERIALRPTXLSX = api + "Reports/RawMaterialRPTXlsx";
export const GETRENEWSUBSCRIPTIONDETAIL =
  api + "BuyersInfo/GetRenewSubscriptionDetails";
export const GETCATEGORYWISECOUNTERSALE =
  api + "CounterSales/GetCategoryWiseCounterSale";
export const GETCATEGORYWISECOUNTERSALEXLSX =
  api + "CounterSales/GetCategoryWiseCounterSaleXlsx";
export const GETMONTLYGSTDETAILSREPORT =
  api + "CounterSales/GetMontlyGSTDetailsXlsx";
export const GETMONTLYGSTDETAILS = api + "CounterSales/GetMontlyGSTDetails";
export const GETDISCOUNTEDITEMS = api + "ItemsMaster/GetDiscontinuedItems";

export const ADVANCEREPORT = api + "Reports/GetEmployeeAdvanceReport";
export const ADVANCEREPORTXLSX = api + "Reports/GetEmployeeAdvanceReportXlsx";
export const GETOVERALLCOUNTERDETAILS =
  api + "CounterSales/GetCounterSalesSummary";
// export const GETOVERALLCOUNTERDETAILS =
//   api + "CounterSales/GetOverAllCounterSalesDetails";
export const GETOVERALLCOUNTERSALEXLSX =
  api + "CounterSales/GetCounterSalesSummaryXlsx";
export const GETASISTANTPAYROLLREPORT =
  api + "Reports/GetAssistantPayrollReport";
export const GETASISTANTPAYROLLREPORTXLSX =
  api + "Reports/GetAssistantPayrollReportXlsx";
export const GETCOUNTERSALESREPORT = api + "CounterSales/GetCounterSalesReport";
export const GETCOUNTERSALESREPORTXLSX =
  api + "CounterSales/GetCounterSalesReportXlsx";
export const GETSTOCKDETAILS = api + "Purchse/GetStockDetails";
export const GETSTOCKDETAILSXLSX = api + "Purchse/GetStockDetailsXlsx";

export const GETPURCHASEDETAILS = api + "Purchse/GetDetails";
export const GETPURCHASEDETAILSXLSX = api + "Purchse/GetDetailsXlsx";
export const PURCHASEADD = api + "Purchse/Add";
export const GETDETAILSEXPENSE = api + "Expense/GetDetails";
export const GETDETAILSEXPENSEXLSX = api + "Expense/GetDetailsXlsx";
export const ADDEXPENSE = api + "Expense/Add";
export const GETDETALS = api + "Expense/GetDetailsXlsx";

export const UPDATEEXPENSE = api + "Expense/Update";
export const GELLALLCATEGORIESHELPSUPPORT =
  api + "FAQCategory/GetAllCategories";
export const GETALLUSERFAQ = api + "FAQs/GetAllUserFAQsByLanguage";
export const ADDBILLERSERICE = api + "ServiceRequest/AddBillerServiceRequest";
// export const ADDB"ServiceRequest/AddBillerServiceRequest"
export const UPDATEPIN = api + "UserMaster/SetMPin";

export const PRINTERSETTING = api + "MyBusiness/UpdatePrinterSettings";
export const GETCUSTOMERNAMEBYMOBILE =
  api + "CounterSales/GetCustomerNameByMobile";
export const GETRATECHANGEHISTORY = api + "ItemsMaster/GetRateChangeHistory";
export const GETCOUNTERSALESSUMMARY =
  api + "CounterSales/GetCounterSalesSummary";
export const GETKYCDOCUMENTS = api + "KYCDocument/GetKYCDocuments";

export const UPLOADDOCUMENTS = api + "KYCDocument/UploadKYCDocumentBase64";
export const GETCUSTOMERADVANCE = api + "BuyersInfo/GetCustomerAdvance";
export const GETBUSINESS = api + "MyBusiness/GetSearchBusiness";
export const GETBILLERITEM = api + "ItemsMaster/GetBillerItems";
export const USERMASTER = api + "UserMaster/Add";

export const VALIDOTP = api + "UserMaster/ValidateUserOTP";
export const USERMPIN = api + "UserMaster/SetUserMPin";
export const ADDCUSTOMERAPPOINMENT =
  api + "Salon/AddCustomerAppointmentForBuyer";
export const ADDCUSTOMERAPPOINMENTANAMONUS =
  api + "Salon/AddCustomerAppointmentForAnonymousBuyer";
export const VALIDCUSTOMERAPPOINMENTANAMONUS =
  api + "Salon/ValidateCustomerAppointmentForAnonymousBuyer";

export const GETCUSTOMERAPPOINMENTS = api + "Salon/GetCustomerAppointments";
export const GETEMPLOYEE = api + "Salon/GetAllEmployeeList";
export const ADDEMPLOYEE = api + "Salon/AddEmployee";
export const UPDATEEMPLOYEE = api + "Salon/UpdateEmployee";
export const ADDCUSTOMERAPPOINMENTI = api + "Salon/AddCustomerAppointment";
export const UPDATECUSTAPPOINMENT = api + "Salon/UpdateCustomerAppointment";

export const GETTERMSERVICE =
  api + "ProductDocumentInformation/GetTermsofServiceContent";
export const GETPRIVACYPOLICY =
  api + "ProductDocumentInformation/GetPrivacyPolicyContent";
export const ADDOFFERS = api + "Salon/AddOffers";
export const GETALLOFFERS = api + "Salon/GetAllOffers";
export const UPDATEOFFERS = api + "Salon/UpdateOffers";

export const GETALLOFFERSBYBILLER = api + "Salon/GetAllOffersByBiller";
export const GETREVIEWANDRATING = api + "Salon/GetReviewAndRating";
export const ADDREVIEWANDRATING = api + "Salon/addReviewAndRating";
export const GETALLREVIEWANDRATING = api + "Salon/getAllReviewAndRating";
export const ADDEXPENSESCATEGORY = api + "Salon/AddExpensesCategory";

export const UDATEEXPENSESCATEGORY = api + "Salon/UpdateExpensesCategory";
export const GETALLCUSTOMERADVACE = api + "BuyersInfo/GetAllCustomerAdvance";
export const GETALLSALARYINCENTIVE = api + "Salon/GetAllSalaryIncentives";
export const GETALLSALARYCOMPONENT = api + "Salon/GetAllSalaryComponent";
export const ADDSALARYINCENTIVE = api + "Salon/AddSalaryIncentive";

export const UPDATESALARYINCENTIVE = api + "Salon/UpdateSalaryIncentive";
export const ADDSALARYCOMPONENT = api + "Salon/AddSalaryComponent";
export const UPDATESALARYCOMPONENT = api + "Salon/UpdateSalaryComponent";
export const GETALLDEDUCTIONCOMPONEN = api + "Salon/GetAllDeductionComponents";
export const ADDDEDUCTIONCOMONEN = api + "Salon/AddDeductionComponent";

export const UPDATEDEDUCTIONCOMPONENT = api + "Salon/UpdateDeductionComponent";
export const BULKSERVICESIMPORT = api + "ItemsMaster/BulkServicesImport";
export const BULKCOUNTERSELLCUSTOMERIMPORT =
  api + "Salon/BulkCounterSalesCustomerImport";
export const BULKIMPORTMPORT = api + "ItemsMaster/BulkProductsImport";
export const GETITEMBYBARCODE = api + "ItemsMaster/GetItemByBarCode";

export const GETALLEDUCATIONALDETAILS = api + "Salon/getAllEducationalDetails";
export const ADDEDUCATIOIN = api + "Salon/AddEducationalDetail";
export const UPDAT__DUCATIOIN = api + "Salon/UpdateEducationalDetail";
export const ADDEXPERINCEDETAIL = api + "Salon/AddExperienceDetail";
export const UPDATEEXPERINCEDETAIL = api + "Salon/UpdateExperienceDetail";

export const GETALLEXPERINCEDETAIL = api + "Salon/GetAllExperienceDetails";
export const GETASSISTANTPAYROLLDETAILFOREMP =
  api + "CounterSales/GetAssistantPayrollSearchV2";
export const GETALLOTHERALLOWANCE = api + "Salon/GetAllOtherAllowances";
export const ADDOTHERALLOWANCE = api + "Salon/AddOtherAllowance";
export const UPDATEOTHERALLOWANCE = api + "Salon/UpdateOtherAllowance";

export const SENDOTP = api + "UserMaster/SendOTP";
export const RESENDOTP = api + "UserMaster/ResendOTP";
export const VALIDATEUSEROTP = api + "UserMaster/ValidateUserOTP";
export const GETALLWHATAPPGROUP = api + "Salon/GetAllWhatsAppCustomerGroups";
export const ADDALLWHATAPPGROUP = api + "Salon/AddWhatsAppCustomerGroup";

export const GETWHATPPMESSAGECOUNT = api + "Salon/GetWhatsAppMessageCount";
export const ADDWHATAPPMESSAGECOUNT = api + "Salon/AddWhatsAppMessageCount";
export const GETALLCUSTOMERCREATEDAPPOINMENT =
  api + "Salon/GetAllCustomerCreatedAppointments";
export const GETBUSSINESSPROFILE = api + "Salon/GetBusinessProfile";
export const UPDATEBUSINESSPROFILE = api + "Salon/UpdateBusinessProfile";

export const ADDBUSINESSPROFILE = api + "Salon/AddBusinessProfile";
export const GETITEMINVENTORY = api + "ItemsMaster/GetMaintainInventoryItems";

export const ADDVENDOR = api + "Salon/AddVendor";
export const UPDATEVENDOR = api + "Salon/UpdateVendor";
export const GETVENDOR = api + "Salon/GetVendor";

export const ADDQUOTATION = api + "Salon/AddQuotation";
export const UPDATEQUOTATION = api + "Salon/UpdateQuotation";
export const ADDPURCHASEORDER = api + "Salon/AddPurchaseOrder";
export const GETPURCHASE = api + "Salon/UpdatePurchaseOrders";
export const UPDATEPURCHASEORDER = api + "Salon/UpdatePurchaseOrder";
export const GETPURCHASEORDERS = api + "Salon/GetPurchaseOrders";
export const GETQUOTATION = api + "Salon/GetQuotations";
export const PAYMENT_CREATE_ORDER = api + "Payment/CreateOrder";
export const VERIFYPAYMENT = api + "Payment/VerifyPaymentSignature";
export const VIEWPAYMENTSLIP = api + "CounterSales/GetAssistantPayrollSearch";

export const GETBILLERTANDCBYTYPE =
  api + "Salon/GetBillerTermsAndConditionsByType";
export const ADDBILLERTANDC = api + "Salon/AddBillerTermsAndConditions";
export const UPDATEBILLERTANDC = api + "Salon/UpdateBillerTermsAndConditions";

export const REDUCESTOCK = api + "Purchse/ReduceStock";
export const GETREDUCESTOCK = api + "Purchse/GetReduceStockDetails";
export const GETASSITANCEPAYMENTPAYROLLV2 =
  api + "CounterSales/GetAssistantPayrollDetailsV2";

export const GETCUSTPMERAPPOINMETREPORT =
  api + "Salon/GetCustomerAppointmentsV2";
export const GETCUSTPMERAPPOINMETREPORTXLSX =
  api + "Salon/GetCustomerAppointmentsV2Xlsx";
export const GETCUSTOMERDETAILS = api + "BuyersInfo/GetCustomerDetails";
export const GETALLEMPLOYEEDETAILREPORT = api + "Salon/GetAllEmployeeListXlsx";

export const GETALLEMPLOYEEATTENDANCE = api + "Salon/GetEmployeeRecordsForDay";
export const GETALLEMPLOYEEATTENDANCEMONTH =
  api + "Salon/GetEmployeeRecordsForMonth";
export const ADDMANUALRECHARGE = api + "UserMaster/AddManualRecharge";
export const ADDWHATSAPPMESSAGECOUNT = api + "Salon/AddWhatsappMessageCount";
export const GETALLWEBADVERTISEMENT = api + "Salon/GetAllWebAdvertisements";
export const ADDADVERTISEMENT = api + "Salon/AddAdvertisement";
export const SAVEEMPLOYEERECORDFORDAY = api + "Salon/SaveEmployeeRecordForDay";
export const UPDATEADVERTISEMENT = api + "Salon/UpdateAdvertisement";
export const GETALLOFFERSBYADMIN = api + "Salon/GetAllOffersByAdmin";
export const ADDALLOFFERSBYADMIN = api + "Salon/AddOffersByAdmin";
export const UPDATEALLOFFERSBYADMIN = api + "Salon/UpdateOffersByAdmin";
export const GETALLMOBILEADVERTISEMENT =
  api + "Salon/GetAllMobileAdvertisements";
export const GETALLUSERDETAILS = api + "UserMaster/GetAllUserDetails";
export const UPDATELUSERDETAILS = api + "UserMaster/UpdateUserDetails";
export const GETEMPLOYEELIST = api + "Salon/GetActiveEmployeeListV2";
export const GETBUSINESSPROFILE = api + "Salon/GetBusinessProfileV2";
export const GETWHATSAPPMESSAGESETTINGS =
  api + "Salon/GetBulkWhatsAppMessageSettings";
export const GETALLJOB = api + "Salon/GetAllJobs";
export const ADDALLJOB = api + "Salon/AddJob";
export const UPDATEALLJOB = api + "Salon/UpdateJob";
export const GETALLAPPLIED = api + "Salon/GetProfilesByJobId";
export const GETALLJOBWITHCANDIDATEAPPLIED =
  api + "Salon/GetAllJobsWithCandiateApplied";
export const GETALLCANDIDATE = api + "Salon/GetCandidateProfiles";
// ...
export const GETCANDIDATEPROFILE = api + "Salon/GetCandidateProfile";
export const UPDATECANDIDATEPROFILE = api + "Salon/UpdateCandidateProfile";
export const ADDCANDIDATEPROFILE = api + "Salon/AddCandidateProfile";
export const APPLYFORJOB = api + "Salon/ApplyForJob";
export const GETCOURSES = api + "Institute/GetCourses";
export const GETCOURSESENQUIRIES = api + "Institute/GetProfilesByCourseId";
export const ADDCOURSE = api + "Institute/AddCourse";
export const UPDATECOURSE = api + "Institute/UpdateCourse";
export const GETINSTITUTE = api + "Institute/GetInstitutes";
export const UPDATEINSTITUTE = api + "Institute/UpdateInstitute";
export const ADDINSTITUTE = api + "Institute/AddInstitute";
export const GETALLCOURSEWITHINSTITUTE =
  api + "Institute/GetAllCoursesWithInstitute";
export const INTRESTEDINSTITUTE = api + "Institute/InterestedForCourse";
export const MYBUSINESSADD = api + "MyBusiness/Add";
export const GETFRANCHISES = api + "Franchise/GetFranchises";
export const UPDATEFRANCHISES = api + "Franchise/UpdateFranchise";
export const ADDFRANCHISES = api + "Franchise/AddFranchise";
export const ADDFRANCHISESREQUIRENMENT =
  api + "Franchise/AddFranchiseRequirement";
export const GETFRANCHISESREQUIRENMENT =
  api + "Franchise/GetFranchiseRequirements";
export const UPDATEFRANCHISESREQUIRENMENT =
  api + "Franchise/UpdateFranchiseRequirement";
export const GETFRANCHISESSUPPORT = api + "Franchise/GetFranchiseSupports";
export const ADDFRANCHISESSUPPORT = api + "Franchise/AddFranchiseSupport";
export const UPDATEFRANCHISESSUPPORT = api + "Franchise/UpdateFranchiseSupport";
export const GETFRANCHISEIMG = api + "Franchise/GetFranchiseImages";
export const ADDFRANCHISEIMG = api + "Franchise/AddFranchiseImage";
export const UPDATEFRANCHISEIMG = api + "Franchise/UpdateFranchiseImage";
export const GETFRANCHISEENQUIRIES = api + "Franchise/GetProfilesByFranchiseId";
export const GETALLFRANCHISE = api + "Franchise/GetAllFranchiseData";
export const INTRESTEDFORFRANCHISE = api + "Franchise/InterestedInFranchise";
export const GETCOMPANYINFORMATION = api + "CompanyProfile/GetCompanyProfiles";
export const ADDCOMPANYINFORMATION = api + "CompanyProfile/AddCompanyProfile";
export const UPDATECOMPANYINFORMATION =
  api + "CompanyProfile/UpdateCompanyProfile";
export const GETCOMPANYPRODUCTS = api + "CompanyProfile/GetCompanyProducts";
export const GETAllCOMPANYPRODUCTS =
  api + "CompanyProfile/GetAllCompanyProducts";
export const ADDCOMPANYPRODUCTS = api + "CompanyProfile/AddCompanyProduct";
export const UPDATECOMPANYPRODUCTS =
  api + "CompanyProfile/UpdateCompanyProduct";
export const GETCOMPANYENQUIRIES = api + "CompanyProfile/GetProfilesByProducts";

export const INTERESTEDCOMPANYENQUIRIES =
  api + "CompanyProfile/InterestedInProducts";
export const ADDCONSULTANTINFORMATION =
  api + "Franchise/AddConsultantInformation";

export const GETCONSULTANTINFORMATION =
  api + "Franchise/GetConsultantInformations";
export const UPDATECONSULTANTINFORMATION =
  api + "Franchise/UpdateConsultantInformation";
export const GETCONSULTANTENQUIRIES =
  api + "Franchise/GetProfilesByConsultantId";
export const requestCONSULTANt = api + "Franchise/RequestForCounsultation";
export const GETCONSULTANTBUSINESSPROFILE =
  api + "Franchise/GetConsultantBusinessProfiles";
export const UPDATECONSULTANTBUSINESSPROFILE =
  api + "Franchise/UpdateConsultantBusinessProfile";
export const ADDCONSULTANTBUSINESSPROFILE =
  api + "Franchise/AddConsultantBusinessProfile";
  export const GETALLCONSULTANTBUSINESSPROFILE =
  api + "Franchise/GetAllConsultantsWithProfiles";

 